import { Icon } from "semantic-ui-react";

import "components/TableFilters/TableQuestionStatusButton/TableQuestionStatusButton.scss";

type TableQuestionStatusButtonProps = {
  selectedQuestionStatuses: string[];
};

export const TableQuestionStatusButton = ({ selectedQuestionStatuses }: TableQuestionStatusButtonProps) => (
  <div className="table-question-status-card-user">
    <Icon className={`${selectedQuestionStatuses.includes("all") ? "filter" : "filters"} table-question-status-card-icon`} size="small" />
  </div>
);
